import { ISearchPrams } from 'models/common'
import API from './axiosClient/axiosClient'
import { IUpdateStaffKPIReq } from 'models/departmentKPI'
import { IStaffUpdateReq, IStaffWeightageReq } from 'models/staff'
import { r } from 'utils/common'

const APIs = {
  STAFF_LIST: 'api/v1/staffs',
  STAFF_DETAIL: 'api/v1/staffs/:id',
  STAFF_KPI_UPDATE: 'api/v1/staff-kpis',
  STAFF_KPI_DEPHEAD_UPDATE: '/api/v1/staff-kpis/actual-performance',
  STAFF_UPDATE_WEIGHTAGE: '/api/v1/staffs/staff-weightage/update'
}

export const getStaffList = async (params: Partial<ISearchPrams>) => {
  if (params.clientId) {
    const paramsFormat = { ...params, clientId: +params.clientId }
    return API.get(APIs.STAFF_LIST, paramsFormat)
  }
}

export const updateStaffKPI = async (values: IUpdateStaffKPIReq) => {
  return API.patch(APIs.STAFF_KPI_UPDATE, values)
}

export const updateStaffKPIDepHead = async (values: IUpdateStaffKPIReq) => {
  return API.patch(APIs.STAFF_KPI_DEPHEAD_UPDATE, values)
}

export const updateStaff = async ({ id, params }: { id: number; params: IStaffUpdateReq }) => {
  return API.patch(
    r(APIs.STAFF_DETAIL, {
      id
    }),
    params
  )
}

export const createStaff = async (values: IStaffUpdateReq) => {
  return API.post(APIs.STAFF_LIST, values)
}

export const deleteStaff = async (id: number) => {
  return API.delete(r(APIs.STAFF_DETAIL, { id }))
}

export const updateWeightage = async (values: IStaffWeightageReq) => {
  return API.patch(APIs.STAFF_UPDATE_WEIGHTAGE, values)
}
